import { render } from "./ZhaiBACard.vue?vue&type=template&id=0223ff50&scoped=true"
import script from "./ZhaiBACard.vue?vue&type=script&lang=js"
export * from "./ZhaiBACard.vue?vue&type=script&lang=js"

import "./ZhaiBACard.vue?vue&type=style&index=0&id=0223ff50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0223ff50"]])

export default __exports__